import { render, staticRenderFns } from "./register-mobile.vue?vue&type=template&id=9b1c3ec0&scoped=true&"
import script from "./register-mobile.vue?vue&type=script&lang=js&"
export * from "./register-mobile.vue?vue&type=script&lang=js&"
import style0 from "./register-mobile.vue?vue&type=style&index=0&id=9b1c3ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1c3ec0",
  null
  
)

export default component.exports